module.exports = __webpack_public_path__ + "media/images/help/line/heading-point-3-01f5d5a31f00c2232004e66277d884c4.svg";